<div id="participant-list">
  <div id="alone" [ngClass]="{ 'col-8 mt-2 mt-md-5': isAlone, 'd-none': !isAlone }">
    <p class="text-center text-monospace h3" style="display: table-cell; color:black">
      Thanks for joining the meeting.
      <br />
      <br />
      Please wait for the {{participantInitials()}} to join.
    </p>
  </div>
  <div [ngClass]="{ 'd-none': isAlone }">
    <!-- <nav class="navbar navbar-expand-lg navbar-dark bg-light shadow">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <button type="button" class="btn btn-lg leave-room" title="Click to leave this room." (click)="onLeaveRoom()">
            Leave "{{ activeRoomName }}" Room?
          </button>
        </li>
      </ul>
    </nav> -->
    <div #list id="list">
    </div>
  </div>
</div>